import * as React from 'react';

import { graphQLClient } from 'src/ui/graph/graphQLClient';
import { getSdk } from 'src/ui/graph/sdk';
import { exportToFile } from 'src/ui/utils/exportToFile';

type VoiceboxReportConnection = {
  id?: string;
};

export const useDownloadVoiceboxReport = (
  connection?: VoiceboxReportConnection | null
) =>
  React.useCallback(
    async (startDate: string, endDate: string) => {
      if (!connection?.id) {
        throw new Error('Connection not found.');
      }
      const sdk = getSdk(graphQLClient);
      const data = await sdk.generateVoiceboxResponseReport({
        input: {
          connectionId: connection.id,
          startDate,
          endDate,
        },
      });
      const report = data.generateVoiceboxResponseReport;
      exportToFile({
        contents: report.csv,
        filename: report.filename,
        mimeType: 'text/csv',
      });
    },
    [connection]
  );
